import { clampDurationHours } from "./orderFormConstants";
import { OrderFormState } from "./types";
import { getVehicleById, ORDER_VEHICLES, OrderVehicle } from "./vehicleData";

export const DEFAULT_ELIT_VEHICLE_ID = ORDER_VEHICLES[0].id;

export function resolveElitVehicleId(vehicleId: string): string {
  return ORDER_VEHICLES.some((vehicle) => vehicle.id === vehicleId)
    ? vehicleId
    : DEFAULT_ELIT_VEHICLE_ID;
}

export function applyElitVehicleId(prev: OrderFormState, vehicleId: string): OrderFormState {
  const resolvedId = resolveElitVehicleId(vehicleId);
  const vehicle = getVehicleById(resolvedId);

  return {
    ...prev,
    vehicleId: resolvedId,
    durationHours: prev.transferMode
      ? 0
      : clampDurationHours(prev.durationHours, vehicle.minHours),
  };
}

export function getElitDurationVehicle(vehicleId: string): OrderVehicle {
  return getVehicleById(resolveElitVehicleId(vehicleId));
}
